// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */

import { getReferrerAttribution } from "@outschool/attribution";
import {
  CreateAccountMutation as CreateAccountMutationType,
  CreateAccountMutationVariables,
} from "@outschool/gql-frontend-generated";
import { gql, useMutation } from "@outschool/ui-apollo";
import React from "react";

import { FullCurrentUserFragment } from "./CurrentUserQuery";

export const createAccountMutation = gql`
  mutation CreateAccount(
    $name: String
    $email: String!
    $password: String!
    $attribution: Attribution
    $browserTimeZone: String
    $locale: UserLocale
    $isLeader: Boolean
    $subscribe: Boolean
    $isGiftCardSignup: Boolean
    $shouldNotSellPersonalInfo: Boolean
    $sellerOrgPrimaryContactName: String
    $osRef: OsRefInput
    $defaultLearnerAttributes: LearnerAttributes
    $requiresMembershipForEnrollment: Boolean
    $integrityToken: String
  ) {
    createAccountWithEmailPassword(
      name: $name
      email: $email
      password: $password
      attribution: $attribution
      browserTimeZone: $browserTimeZone
      locale: $locale
      isLeader: $isLeader
      subscribe: $subscribe
      isGiftCardSignup: $isGiftCardSignup
      shouldNotSellPersonalInfo: $shouldNotSellPersonalInfo
      sellerOrgPrimaryContactName: $sellerOrgPrimaryContactName
      osRef: $osRef
      defaultLearnerAttributes: $defaultLearnerAttributes
      requiresMembershipForEnrollment: $requiresMembershipForEnrollment
      integrityToken: $integrityToken
    ) {
      uid
      sessionToken
      refreshToken
      currentUser {
        ...FullCurrentUserFragment
      }
    }
  }
  ${FullCurrentUserFragment}
`;

export function useCreateAccountMutation() {
  const [createAccount, executionStatusVars] = useMutation<
    CreateAccountMutationType,
    CreateAccountMutationVariables
  >(createAccountMutation);
  // Wrap the createAccount mutation to add attribution when it's called
  const createAccountFn = React.useCallback(
    async (
      options: Parameters<typeof createAccount>[0],
      anonymousId?: string
    ) => {
      return await createAccount({
        ...options,
        variables: {
          ...(options?.variables! ?? {}),
          osRef: {
            ...getReferrerAttribution(),
            anonymousId,
          },
        },
      });
    },
    [createAccount]
  );

  return [createAccountFn, executionStatusVars] as const;
}
